var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('eventsService', ['$http', function ($http) {
    return {
        digitalEventRegistration: function (eventId, user) {
            return $http.post("storefrontapi/digitaleventregistration", {
                FK_EventId: eventId,
                FK_UserId: user.userid,
                CustomerName: user.name,
                CustomerEmail: user.email,
                PhoneNumber: user.phone,
                Country: user.country
            });
        },
        getDigitalEventInfo: function (eventId) {
            return $http.get('storefrontapi/digitalevent?eventId=' + eventId);
        },
        getDigitalEventSaleItem: function (discountId,eventId) {
            return $http.get(
                "storefrontapi/getdigitaleventactivesale?discountId=" + discountId + "&eventId=" + eventId
            );
        },
        getDigitalEvents: function (count) {
            if(angular.isDefined(count) && count > 0){
                return $http.get('storefrontapi/digitalevents?count='+count);
            }
            else{
                return $http.get('storefrontapi/digitalevents');
            }
        },
    }
}]);
